import { render, staticRenderFns } from "./channelPostback.vue?vue&type=template&id=58a71bc8&scoped=true"
import script from "./channelPostback.vue?vue&type=script&lang=js"
export * from "./channelPostback.vue?vue&type=script&lang=js"
import style0 from "./channelPostback.vue?vue&type=style&index=0&id=58a71bc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a71bc8",
  null
  
)

export default component.exports